import { afterRenderEffect } from '@angular/core';

const SCROLL_MARGIN = 80;

interface TimelineScrollTarget {
  element: HTMLElement;
  key: string;
}

export function scrollTimeline(target: () => TimelineScrollTarget | undefined): void {
  let currentKey: string | undefined;

  afterRenderEffect(() => {
    const next = target();
    if (!next || next.key === currentKey) return;

    const viewport = next.element.closest<HTMLElement>('.main-content');
    if (!viewport) return;

    viewport.scrollTo({
      top:
        viewport.scrollTop +
        next.element.getBoundingClientRect().top -
        viewport.getBoundingClientRect().top -
        SCROLL_MARGIN,
      behavior: currentKey === undefined ? 'instant' : 'smooth',
    });
    currentKey = next.key;
  });
}
